export default function initKeyVisualSlider() {
  const sliders = document.querySelectorAll("[data-key-visual-slider]");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll(".keyVisual__slide");
    if (slides.length <= 1) return;

    let currentIndex = 0;
    const intervalMs = 5000; // 切替間隔

    setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;
      slides[currentIndex].classList.remove("is-active");
      slides[nextIndex].classList.add("is-active");
      currentIndex = nextIndex;
    }, intervalMs);
  });
}
